import {
  ModuleViewBodyWrapper,
  ModuleViewHeaderWrapper,
  ModuleViewWrapper,
} from './styles';
import { Badge, Flex } from '@mantine/core';
import { useIntl } from 'react-intl';

interface IProps {
  titleHeader?: string;
  children: JSX.Element;
  className?: string;
  bodyClassName?: string;
  showSoonTag?: boolean;
}

export function ModuleView(props: IProps) {
  const { formatMessage } = useIntl();
  const {
    titleHeader,
    children,
    className,
    bodyClassName,
    showSoonTag = false,
  } = props;
  return (
    <ModuleViewWrapper className="module-wrapper">
      <ModuleViewBodyWrapper
        className={`${bodyClassName ? bodyClassName : ''}`}
      >
        {titleHeader && (
          <ModuleViewHeaderWrapper className={`${className ? className : ''}`}>
            <Flex w={"100%"} justify={"space-between"}>
              <h2
                style={{ marginBottom: '16px' }}
                className={`${className ? className : ''}`}
              >
                {titleHeader}
              </h2>
              {showSoonTag && (
                <Badge bg='#cdcdd7' color='#303030' className="badge" variant="filled">
                  {formatMessage({ id: 'soon' })}
                </Badge>
              )}
            </Flex>
          </ModuleViewHeaderWrapper>
        )}
        {children}
      </ModuleViewBodyWrapper>
    </ModuleViewWrapper>
  );
}
